export { default } from "./Call";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/ClientsList/Call/index.js